import { useState, useRef, useCallback } from "react";
import { customAlphabet } from "nanoid";
const generateConversationId = customAlphabet("abcdefghijklmnopqrstuvwxyz1234567890", 10);
const useConversationState = () => {
  const [conversationId, setConversationId] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("conversationId") || null;
  });
  const [sharedConversationId, setSharedConversationId] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("conversationId")) {
      return null;
    }
    return params.get("sharedConversationId") || null;
  });
  const [followUpQuestions, setFollowUpQuestions] = useState([]);
  const [conversationHistory, setConversationHistory] = useState([]);
  const [isActivelyStreaming, setIsActivelyStreaming] = useState(false);
  const [streamingAIResponse, setStreamingAIResponse] = useState("");
  const [streamingDevInfo, setStreamingDevInfo] = useState(null);
  const [conversationPageContext, setConversationPageContext] = useState(null);
  const [isSharedView, setIsSharedView] = useState(false);
  const [sharedByUserName, setSharedByUserName] = useState(void 0);
  const [sharedAtMessageIndex, setSharedAtMessageIndex] = useState(void 0);
  const [sourceConversationId, setSourceConversationId] = useState(void 0);
  const [sourceCheckpointIndex, setSourceCheckpointIndex] = useState(void 0);
  const [pendingShareConversationId, setPendingShareConversationId] = useState(null);
  const [voiceCallOpen, setVoiceCallOpen] = useState(false);
  const onEndedCallbacksRef = useRef(/* @__PURE__ */ new Set());
  const openVoiceCall = useCallback((overrideConversationId) => {
    setConversationId((current) => {
      if (overrideConversationId) return overrideConversationId;
      if (current) return current;
      return generateConversationId();
    });
    setVoiceCallOpen(true);
  }, []);
  const registerOnVoiceCallEnded = useCallback((cb) => {
    onEndedCallbacksRef.current.add(cb);
    return () => {
      onEndedCallbacksRef.current.delete(cb);
    };
  }, []);
  const closeVoiceCall = useCallback(() => {
    setVoiceCallOpen(false);
    const snapshot = Array.from(onEndedCallbacksRef.current);
    for (const cb of snapshot) {
      try {
        cb();
      } catch (err) {
        console.error("[voice] onEnded callback failed", err);
      }
    }
  }, []);
  const clearStreamingState = useCallback(() => {
    setStreamingAIResponse("");
    setStreamingDevInfo(null);
  }, []);
  return {
    conversationId,
    setConversationId,
    sharedConversationId,
    setSharedConversationId,
    conversationHistory,
    setConversationHistory,
    isActivelyStreaming,
    setIsActivelyStreaming,
    streamingAIResponse,
    setStreamingAIResponse,
    followUpQuestions,
    setFollowUpQuestions,
    streamingDevInfo,
    setStreamingDevInfo,
    clearStreamingState,
    conversationPageContext,
    setConversationPageContext,
    // Sharing state
    isSharedView,
    setIsSharedView,
    sharedByUserName,
    setSharedByUserName,
    sharedAtMessageIndex,
    setSharedAtMessageIndex,
    sourceConversationId,
    setSourceConversationId,
    sourceCheckpointIndex,
    setSourceCheckpointIndex,
    pendingShareConversationId,
    setPendingShareConversationId,
    // Voice overlay (Plan 7a / D-63)
    voiceCallOpen,
    openVoiceCall,
    closeVoiceCall,
    registerOnVoiceCallEnded
  };
};
export {
  useConversationState
};
//# sourceMappingURL=useConversationState.js.map
